import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Popup, ControlGroup } from '@ui';
import I18n from '@utils/i18n';

const NAMESPACE = 'filters';

function FilterToggle({ filters }) {
  const anchor = useRef(null);
  const [show, setShow] = useState(false);

  return (
    <div>
      <Button ref={anchor} onClick={() => setShow((prev) => !prev)}>
        <i className="fa-light fa-filter" />
      </Button>

      <Popup anchor={anchor.current} show={show} onClose={() => setShow(false)}>
        <Popup.Section>
          <Popup.Title>{I18n.t(`${NAMESPACE}.manage_filters`)}</Popup.Title>
        </Popup.Section>
        <Popup.Section fillHeight>
          <ControlGroup
            controlType="checkbox"
            items={filters.map((filter) => ({
              value: filter.field,
              label: I18n.t(`${NAMESPACE}.${filter.locale}`),
              disabled: filter.locked,
              tooltip: filter.tooltip
            }))}
            value={{
              root: filters.filter((f) => f.active).map((f) => f.field),
              children: {}
            }}
            onChange={(newValue) => {
              const activeFields = filters.filter((f) => f.active).map((f) => f.field);
              const changedField =
                newValue.root.find((v) => !activeFields.includes(v)) ??
                activeFields.find((v) => !newValue.root.includes(v));
              if (changedField) {
                filters.find((f) => f.field === changedField)?.onToggle?.();
              }
            }}
          />
        </Popup.Section>
      </Popup>
    </div>
  );
}

FilterToggle.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      active: PropTypes.bool,
      locked: PropTypes.bool,
      onToggle: PropTypes.func,
      tooltip: PropTypes.string
    })
  )
};

FilterToggle.defaultProps = {
  filters: []
};

export default FilterToggle;
